import { get } from 'axios';

const store = {
	namespaced: true,
	state: {
		cookieContent: ''
	},
	mutations: {
		content(state, { prop, html }) {
			state[prop] = html;
		}
	},
	actions: {
		cms({ commit, state }, { prop, slug }) {
			if (!state[prop]) {
				get(`/service/cms/${slug}`).then(({ data }) => {
					commit('content', {
						prop,
						html: data.html
					});
				});
			}
		}
	}
};

export default store;
